import { render, staticRenderFns } from "./InquiryServicesListLiew.vue?vue&type=template&id=4b19fce6&scoped=true"
import script from "./InquiryServicesListLiew.vue?vue&type=script&lang=js"
export * from "./InquiryServicesListLiew.vue?vue&type=script&lang=js"
import style0 from "./InquiryServicesListLiew.vue?vue&type=style&index=0&id=4b19fce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19fce6",
  null
  
)

export default component.exports